import {
  adminRoutes,
  publicRoutes,
  heatingCalcRoutes,
  limitedContentUserRoutes,
} from "../router/page-routes";
import { ROLES } from "../constants/roles";

const roleRoutes = {
  [ROLES.SUPER_ADMIN]: adminRoutes, // Super Admin (5)
  [ROLES.ADMIN]: adminRoutes, // Admin (4)
  [ROLES.HEATING_USER]: heatingCalcRoutes, // Heating User (3)
  [ROLES.LIMITED_CONTENT_USER]: limitedContentUserRoutes, // Limited Content User (6)
};

export const getRoutes = (adminRole) => roleRoutes[adminRole] || publicRoutes;
